let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("97Y1C")).then(() => parcelRequire('iEK1O'));